import styled from 'foundations-theming/utils';
export const EditCellContentAndValidationAlertWrapper = styled.div.withConfig({
  displayName: "StyledEditCellComponents__EditCellContentAndValidationAlertWrapper"
})(["display:flex;align-items:center;justify-content:space-between;"]);
export const PropertyCellDisplayContentIndicatorsWrapper = styled.span.withConfig({
  displayName: "StyledEditCellComponents__PropertyCellDisplayContentIndicatorsWrapper"
})(["align-items:center;display:inline-flex;gap:", ";"], ({
  theme
}) => theme.space['200']);